import ReactSignatureCanvasImport from "react-signature-canvas";

// With Vite 8 ESM exports of packages are required, signature-canvas is not updated yet so we juggle the types to get the default export
type ReactSignatureCanvasType = typeof ReactSignatureCanvasImport;
const MaybeDefaultCanvas = ReactSignatureCanvasImport as
  | (ReactSignatureCanvasType & { default: never })
  | { default: ReactSignatureCanvasType };
const ReactSignatureCanvas = MaybeDefaultCanvas.default
  ? MaybeDefaultCanvas.default
  : (MaybeDefaultCanvas as ReactSignatureCanvasType);

import { styled } from "simplydo/react/styled";
import { Card, CardContent } from "simplydo/react/ui/card";

const CanvasContainer = styled(Card)`
  width: 100%;
  margin: 0;
  background-color: #fff;
  padding: 0px !important;
`;

const ClearText = styled.span`
  color: gray;
  text-decoration-line: underline;
  margin: 5px 0;
  display: block;
  cursor: pointer;
`;

type SignatureCanvasProps = {
  canvasRef: React.RefObject<ReactSignatureCanvasImport | null>;
  width?: string;
  height?: string;
};

const SignatureCanvas = ({
  canvasRef,
  width = "100%",
  height = "30px",
}: SignatureCanvasProps) => {
  return (
    <div>
      <CanvasContainer style={{ width, height }}>
        <CardContent style={{ padding: 0 }}>
          <ReactSignatureCanvas
            ref={canvasRef}
            canvasProps={{ width, height }}
          />
        </CardContent>
      </CanvasContainer>
      <ClearText onClick={() => canvasRef.current?.clear()}>
        Clear signature
      </ClearText>
    </div>
  );
};

export default SignatureCanvas;
